import Layout from "components/layout/Layout";
import { useState } from "react";
import { Collapse } from "react-collapse";


const FAQ_CATEGORIES = [
  {
    category: "General Questions",
    items: [
      {
        title: "What is BodyLytiX?",
        key: 1,
        content:
          "BodyLytiX is a fitness and wellness platform powered by AI. We connect with your devices, like Garmin and Apple Health, to provide personalized insights and coaching tailored to your goals.",
      },
      {
        title: "Who can use BodyLytiX?",
        key: 2,
        content:
          "Anyone passionate about improving their health and fitness, whether you're just starting or an experienced athlete.",
      },
      {
        title: "How do I get started with BodyLytiX?",
        key: 3,
        content:
          "Sign up and create an account, connect your Garmin and you can start to analyze your progress!",
      },
    ],
  },
  {
    category: "Device Integration",
    items: [
      {
        title: "Which devices does BodyLytiX work with?",
        key: 4,
        content:
          "Currently, BodyLytiX supports Garmin and Apple Health integrations, with plans to expand to other popular fitness platforms in the future.",
      },
      {
        title: "How do I sync my device with BodyLytiX?",
        key: 5,
        content:
          "After creating an account, navigate to the settings and select 'Device Integration.' Follow the prompts to connect your Garmin or Apple Health account.",
      },
      {
        title: "What should I do if my device won’t sync?",
        key: 6,
        content:
          "Check your device settings to ensure permissions are enabled for BodyLytiX. If issues persist, visit our <a href=\"/help\">Help Center</a> or contact support at <a href=\"mailto:support@bodylytix.ai\">support@bodylytix.ai.</a>",
      },
    ],
  },
  {
    category: "Features and Functionality",
    items: [
      {
        title: "What are AI Coaches, and how do they work?",
        key: 7,
        content:
          "AI Coaches are virtual guides that provide personalized training plans, insights, and recommendations based on your fitness data. You can choose from pre-built coaches or create your own, tailored to your goals.",
      },
      {
        title: "Can I share my custom coach with others?",
        key: 8,
        content:
          "Yes! BodyLytiX allows you to make your custom coaches publicly available so other users can discover and use them. Popular coaches will rise to the top based on user engagement and results.",
      },
      {
        title: "Does BodyLytiX support mental wellness tracking?",
        key: 9,
        content:
          "We’re working on expanding features to include mental wellness insights like stress and mood tracking. Stay tuned for updates!",
      },
    ]
  },
  {
    category: "Privacy and Security",
    items: [
      {
        title: "How does BodyLytiX protect my data?",
        key: 10,
        content:
          "We use advanced encryption to secure your data both in transit and at rest. Our platform is built on AWS, ensuring robust security measures and compliance with global standards like GDPR.",
      },
      {
        title: "Who has access to my data?",
        key: 11,
        content:
          "Only you have full access to your personal data. BodyLytiX uses anonymized data to improve the platform but does not share your identifiable information without your explicit consent.",
      },
      {
        title: "Can I delete my data?",
        key: 12,
        content:
          "Yes, you can request to delete your data at any time through the settings menu or by contacting support.",
      },
    ]
  },
  {
    category: "Subscription and Payments",
    items: [
      {
        title: "Is BodyLytiX free to use?",
        key: 13,
        content:
          "BodyLytiX offers a free version with core features. For advanced analytics, AI-driven insights, and premium coaching tools, you can subscribe to our premium plan.",
      },
      {
        title: "How much does the premium plan cost?",
        key: 14,
        content:
          "Our pricing is flexible, with monthly and annual subscription options. Visit <a href\"/pricing\">our pricing page</a> for details.",
      },
      {
        title: "How can I cancel my subscription?",
        key: 15,
        content:
          "You can cancel your subscription anytime through your account settings. Your premium access will remain active until the end of the billing cycle.",
      },
    ]
  },
  {
    category: "Support",
    items: [
      {
        title: "How do I contact customer support?",
        key: 16,
        content:
          "You can reach us via email at support@bodylytix.ai or use the in-app support feature to chat with our team.",
      },
    ]
  },
];

export default function Faq() {
  const [isActive, setIsActive] = useState({
    status: false,
    key: 1,
  });

  const handleToggle = (key) => {
    if (isActive.key === key) {
      setIsActive({
        status: false,
      });
    } else {
      setIsActive({
        status: true,
        key,
      });
    }
  };
  return (
    <>
      <Layout
        headerStyle={1}
        footerStyle={1}
        breadcrumbTitle={
          <>
            General <span>Questions</span>
          </>
        }
      >
        <section className="faq-area pb-150">
          
          <div className="container">
            <p className="info-one pb-100">
              Welcome to the BodyLytiX FAQ section! Below are answers to some of the most common questions about our platform. If you don’t see your question here, feel free to contact our support team for assistance.
            </p>
            {FAQ_CATEGORIES.map((category) => (
              <div className="row pb-100">
                <div className="col-lg-12">
                  <h2>{category.category}</h2>
                  <div className="faq-wrap">
                    <div className="accordion">
                    {category.items.map((faq) => (
                      <div
                        className={
                          isActive.key === faq?.key
                            ? "accordion-item active"
                            : "accordion-item"
                        }
                        key={faq?.key}
                      >
                        <h2 className="accordion-header">
                          <button
                            className={
                              isActive.key === faq?.key
                                ? "accordion-button"
                                : "accordion-button collapsed"
                            }
                            type="button"
                            onClick={() => handleToggle(faq?.key)}
                          >
                            {faq?.title}
                          </button>
                        </h2>
                        <Collapse isOpened={isActive.key === faq?.key}>
                          <div
                            className={
                              isActive.key === faq?.key
                                ? "accordion-collapse collapse show"
                                : "accordion-collapse collapse"
                            }
                          >
                            <div className="accordion-body">
                              {/* <p>{faq?.content}</p> */}
                              <p dangerouslySetInnerHTML={{ __html: faq?.content }} />
                            </div>
                          </div>
                        </Collapse>
                      </div>
                    ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </Layout>
    </>
  );
}
